import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { t } from './i18n.es.js';
import { styled, Currency } from '@teko/ds-desktop';
import { DiscountFilled, VoucherColored } from '@teko/ds-icon';
import { D as DetailGifts, Q as Quantity } from './DetailGifts-73e7c7fc.js';

const DefaultPromotions = ({ gifts, discount, vouchers = [], }) => {
    return (jsxs(Fragment, { children: [discount > 0 && (jsxs(Wrapper, { children: [jsx("div", Object.assign({ style: { width: '8%' } }, { children: jsx(DiscountFilled, { size: 20, color: "primary500", style: { marginLeft: '5px' } }, void 0) }), void 0), jsxs("div", Object.assign({ style: { width: '92%' } }, { children: [t('Giảm trực tiếp'), " ", jsx(StyledCurrency, { value: discount }, void 0)] }), void 0)] }, void 0)), !!gifts.length && jsx(DetailGifts, { gifts: gifts }, void 0), vouchers.map((voucher, index) => (jsxs(Wrapper, { children: [jsx("div", Object.assign({ style: { width: '8%' } }, { children: jsx(VoucherColored, { size: 20, color: "primary500", style: { marginLeft: '5px' } }, void 0) }), void 0), jsxs("div", Object.assign({ style: { width: '92%' } }, { children: [t('Tặng'), " ", jsxs(Quantity, { children: ["x", voucher.quantity] }, void 0), ' ', jsx(StyledVoucherName, { children: voucher.name }, void 0)] }), void 0)] }, index)))] }, void 0));
};
const Wrapper = styled.div `
  margin-top: 2px;
  display: flex;
`;
const StyledCurrency = styled(Currency) `
  margin: 0 4px;
  color: #ed2101;
  font-weight: 500;
`;
const StyledVoucherName = styled.span `
  color: #ed2101;
  font-weight: 500;
`;

export { DefaultPromotions as D };
